/*
 * Cart page behavior: quantity stepper with AJAX line updates,
 * plus a live character counter for the order note field.
 */
class BhCart extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-quantity-change]');
      if (button) {
        event.preventDefault();
        this.changeQuantity(button);
      }
    });

    const noteInput = this.querySelector('[data-note-input]');
    if (noteInput) {
      this.updateNoteCounter(noteInput);
      noteInput.addEventListener('input', () => this.updateNoteCounter(noteInput));
    }
  }

  updateNoteCounter(noteInput) {
    const counter = this.querySelector('[data-note-counter]');
    if (!counter) return;
    const max = noteInput.dataset.noteMax;
    counter.textContent = `${noteInput.value.length}/${max}`;
  }

  changeQuantity(button) {
    const row = button.closest('[data-line-item]');
    const input = row.querySelector('[data-quantity-input]');
    const delta = button.dataset.quantityChange === 'increase' ? 1 : -1;
    const quantity = Math.max(0, (parseInt(input.value, 10) || 0) + delta);

    row.classList.add('is-updating');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: row.dataset.lineKey, quantity }),
    })
      .then((response) => {
        if (!response.ok) throw new Error('Cart update failed');
        return response.json();
      })
      .then(() => window.location.reload())
      .catch(() => this.showError(row));
  }

  showError(row) {
    row.classList.remove('is-updating');
    let message = row.querySelector('[data-quantity-error]');
    if (!message) {
      message = document.createElement('div');
      message.setAttribute('data-quantity-error', '');
      message.setAttribute('role', 'alert');
      message.className = 'cart-item-error';
      const cell = row.querySelector('[data-quantity-input]')?.closest('td') || row;
      cell.appendChild(message);
    }
    message.textContent = "Couldn't update quantity. Please try again.";
  }
}

customElements.define('bh-cart', BhCart);
